var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_336_2292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.125 0V10.5H29V0H18.125ZM27.1875 1.75V8.75H19.9375V1.75H27.1875ZM14.5 1.75V0H16.3125V3.5H14.5V7H12.6875V1.75H14.5ZM14.5 10.5V7H16.3125V10.5H14.5ZM10.875 14V12.25H12.6875V10.5H14.5V14H16.3125V12.25H25.375V14H18.125V15.75H12.6875V14H10.875ZM10.875 14V15.75H3.625V14H1.8125V15.75H0V12.25H5.4375V14H10.875ZM29 15.75H27.1875V12.25H29V15.75ZM27.1875 15.75H25.375V19.25H29V17.5H27.1875V15.75ZM19.9375 15.75H23.5625V17.5H21.75V19.25H19.9375V15.75ZM23.5625 21V19.25H21.75V21H19.9375V22.75H16.3125V24.5H21.75V21H23.5625ZM23.5625 21H29V22.75H25.375V24.5H23.5625V21ZM16.3125 19.25V21H18.125V17.5H12.6875V19.25H16.3125Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.4999,
    cy: 14,
    rx: 7.04286,
    ry: 6.58824,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1929 16.5499H11.8072C11.6882 16.5499 11.574 16.5101 11.4899 16.4393C11.4057 16.3685 11.3584 16.2725 11.3584 16.1724C11.3584 16.0723 11.4057 15.9763 11.4899 15.9055C11.574 15.8347 11.6882 15.795 11.8072 15.795H17.1929C17.312 15.795 17.4261 15.8347 17.5103 15.9055C17.5944 15.9763 17.6417 16.0723 17.6417 16.1724C17.6417 16.2725 17.5944 16.3685 17.5103 16.4393C17.4261 16.5101 17.312 16.5499 17.1929 16.5499Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2593 13.4448C16.2257 13.3759 16.1685 13.3169 16.095 13.2752C16.0215 13.2336 15.935 13.2112 15.8464 13.2108H14.9488V10.9461C14.9488 10.846 14.9015 10.75 14.8173 10.6792C14.7332 10.6084 14.619 10.5686 14.5 10.5686C14.381 10.5686 14.2668 10.6084 14.1826 10.6792C14.0985 10.75 14.0512 10.846 14.0512 10.9461V13.2108H13.1536C13.065 13.2112 12.9785 13.2336 12.905 13.2752C12.8315 13.3169 12.7743 13.3759 12.7407 13.4448C12.7063 13.5135 12.6969 13.5893 12.7137 13.6625C12.7304 13.7357 12.7726 13.8031 12.8349 13.8562L14.1813 14.9886C14.224 15.0229 14.2744 15.0499 14.3294 15.0678C14.3832 15.0878 14.4413 15.0981 14.5 15.0981C14.5587 15.0981 14.6168 15.0878 14.6705 15.0678C14.7256 15.0499 14.776 15.0229 14.8186 14.9886L16.1651 13.8562C16.2273 13.8031 16.2695 13.7357 16.2863 13.6625C16.3031 13.5893 16.2937 13.5135 16.2593 13.4448Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.625 3.5H7.25V7H3.625V3.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.875 0V10.5H0V0H10.875ZM9.0625 1.75H1.8125V8.75H9.0625V1.75ZM7.25 21H3.625V24.5H7.25V21Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.875 17.5V28H0V17.5H10.875ZM1.8125 19.25V26.25H9.0625V19.25H1.8125ZM21.75 3.5H25.375V7H21.75V3.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6875 21H14.5V26.25H21.75V28H12.6875V21ZM29 24.5V28H23.5625V26.25H27.1875V24.5H29Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_336_2292"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.291d0a6e179d7009fa216a4ca03b30a6.svg";
export { ForwardRef as ReactComponent };